<template>
  <div>
    <router-view />
    <appAlert />
  </div>
</template>

<script>
import appAlert from "@/packages/dashboard/plugins/appAlert/appAlert";
export default {
  name: "RefundComponent",
  components: { appAlert },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Refund/refunds");
      v.$store.dispatch("Refund/getStudentPaymentBalance");
    });
  },
};
</script>

<style scoped></style>
